import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestReassignPopup', {
    doneButtonText: 'Reassign request',
    popupTitle: 'Reassign',
    doneButtonTitleWithName: 'Reassign this request to {displayName}',
    doneButtonTitle: 'Reassign request',
    cannotSelectApprover:
        '{displayName} can not be selected as an Approver since they are already an Approver in this step',
    cannotSelectReviewer:
        '{displayName} can not be selected as a Reviewer since they are already a Reviewer in this step',
    descriptionApprover:
        'Reassign the request to another Approver.{br}Please provide a comment to let {authorName} as well as the Approvers know why you decided to do this.',
    descriptionReviewer:
        'Reassign the request to another Reviewer.{br}Please provide a comment to let {authorName} as well as the Reviewers know why you decided to do this.',
});
